import React from 'react';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

interface btnProps {
  label: string;
  className?: string;
}

export default function RedirectButton({ label, className }: btnProps) {
  const interestHref = `/talk-to-expert`;
  
  const btnClassName = `bg-cic-blue-500 flex gap-4xs items-center justify-center px-m py-xs rounded-sm text-base-white text-sm leading-sm font-semibold hover:no-underline active:bg-cic-blue-500 ${className || ''}`;

  return (
    <a
      href={interestHref}
      className={btnClassName}>
      <span className="flex items-center">{label}</span>
      <ChevronRightIcon className="w-[20px] h-[20px] flex-shrink-0" />
    </a>
  )
}
